import React from "react";

function FooterComponent(props) {
  return (
    <div>
      <div className="card text-center">
        <div className="card-footer text-muted">@2022 Sang PHAM</div>
      </div>
    </div>
  );
}

export default FooterComponent;
